(() => {
  const SKIP_SELECTOR = 'script, style, textarea, input, select, option';
  const euroPrefixPattern = /((?:EUR|€)\s*)(\d{1,3}(?:[.,]\d{3})*|\d+),(\d{2})(?!\d)/gi;
  const euroSuffixPattern = /(\d{1,3}(?:[.,]\d{3})*|\d+),(\d{2})(\s*(?:EUR|€))/gi;
  let pendingFrame = null;
  const pendingRoots = new Set();

  const formatWhole = (value) => value.replace(/\./g, ',');

  const normalizePriceText = (text) => text
    .replace(euroPrefixPattern, (_match, currency, whole, decimals) => `${currency}${formatWhole(whole)}.${decimals}`)
    .replace(euroSuffixPattern, (_match, whole, decimals, currency) => `${formatWhole(whole)}.${decimals}${currency}`);

  const shouldCheckText = (text) => text.includes('€') || /EUR/i.test(text);

  const normalizeTextNode = (node) => {
    if (!node.nodeValue || !shouldCheckText(node.nodeValue)) return;

    const nextValue = normalizePriceText(node.nodeValue);
    if (nextValue !== node.nodeValue) {
      node.nodeValue = nextValue;
    }
  };

  const normalizeRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(SKIP_SELECTOR)) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest(SKIP_SELECTOR)) return NodeFilter.FILTER_REJECT;
        return shouldCheckText(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });

    while (walker.nextNode()) {
      normalizeTextNode(walker.currentNode);
    }
  };

  const scheduleNormalize = (root) => {
    if (root) pendingRoots.add(root);
    if (pendingFrame) return;

    pendingFrame = window.requestAnimationFrame(() => {
      pendingFrame = null;
      const roots = Array.from(pendingRoots);
      pendingRoots.clear();
      roots.forEach(normalizeRoot);
    });
  };

  const start = () => {
    normalizeRoot(document.body);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'characterData') {
          scheduleNormalize(record.target);
          return;
        }

        record.addedNodes.forEach((node) => scheduleNormalize(node));
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
